import { api } from "../../lib";

export interface RolePermission {
  id: string;
  roleId: string;
  permissionId: string;
  createdAt: string;
  role?: { name: string } | null;
  permission?: { name: string; description: string } | null;
}

export interface CreateRolePermissionData {
  roleId: string;
  permissionId: string;
}

export const rolePermissionsService = {
  getAll: async () => {
    return api.get<RolePermission[]>("/admin/role-permissions");
  },

  getByRoleId: async (roleId: string) => {
    return api.get<RolePermission[]>(`/admin/roles/${roleId}/permissions`);
  },

  create: async (data: CreateRolePermissionData) => {
    return api.post<RolePermission>("/admin/role-permissions", data);
  },

  delete: async (id: string) => {
    await api.delete<void>(`/admin/role-permissions/${id}`);
  },
};
